// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetFaqs,
    DeleteFaqById,
    UpdateFaqsPositions
} from "../../redux/actions";


class FAQ extends Component {
    constructor(props) {
        super(props);
        this.deleteFaq = deleteItem.bind(this, props.DeleteFaqById, 'սլայդերը');
        this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount() {
        this.props.GetFaqs();
    }

    getNestableItems(list, parent = null) {
        const {mainLanguage} = this.props;
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            const trData = item?.translations?.find(tr => tr.languageId === mainLanguage);
            const title = trData?.answer || '';

            items.push({
                id: item.id,
                index: index,
                title: title,
                isHidden: item.isHidden,
                link: {
                    pathname: `faq/edit/${item.id}`,
                },
                deleteCb: () => this.deleteFaq(item.id),
                children: []
            })
        });
        return items;
    }

    async onPositionChange(items, item) {
        const movedFaqId = item.id;
        const {faqList} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~faqList.findIndex(m => m.id === movedFaqId) &&
            ~positionedItems.findIndex(m => m.id === movedFaqId)) {
            // first level menu was re-positioned in first level
            await this.props.UpdateFaqsPositions(positionedItems);
            this.props.GetFaqs();
        }
    }

    render() {
        let {faqList} = this.props;
        let items = this.getNestableItems(faqList);
        return <PageWrapper pageTitle={'FAQ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/faq/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetFaqs,
    DeleteFaqById,
    UpdateFaqsPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);
